<template>
    <div class="p-2">

        <div class="form-group d-flex">
            <div class="col-10">{{ $t('translations.description')}}: </div><div class="col-14"> {{$parent.item.description}}</div>
        </div>

        <div class="form-group d-flex">
            <div v-if='$parent.item.properties' class="col-10">{{ $t('translations.properties')}}: </div><pre class="col-14">{{parseProperties()}}</pre>
        </div>

        <div class="form-group d-flex">
            <div v-if='$parent.item.user' class="col-10">{{ $t('translations.event_triggered_by')}}: </div><div class="col-14">{{getUserDetails()}} <button class='btn btn-primary btn-round btn-sm' v-on:click='goToUser()'>{{ $t('translations.view')}}</button></div>
        </div>

        <div class="form-group d-flex">
            <div v-if='$parent.item.user' class="col-10">{{ $t('translations.created_at')}}: </div><div class="col-14">{{item.created_at | formatDateTime}}</div>
        </div>

    </div>
</template>

<script>
	export default {
        props: [
            'item',
            'event'
        ],

        data() {
            return {
            }
        },
        methods: {
            getName() {
                return this.$parent.item.log_name;
            },
            getUserDetails() {
                var details = "";
                if(this.$parent.item && this.$parent.item.user) {
                    details = (this.is_patient(this.$parent.item.user) ? this.tBrandKey('Client').toUpperCase() + ": " : this.$t('Staff').toUpperCase() + ": ") + this.formatName(this.$parent.item.user);
                    if(this.$parent.item.user.email) {
                        details += " <" + this.$parent.item.user.email + ">";
                    }

                }
                return details;
            },
            goToUser() {
                if(this.is_patient(this.$parent.item.user)) {
                    this.$router.push({path: "/patient-list/patient-show/" + this.$parent.item.user.id});
                }
                else {
                    this.$router.push({path: "/staff-list/staff-show/" + this.$parent.item.user.id});
                }
            },
            parseProperties() {
                console.log("JSON: |" + this.$parent.item.properties + "|");
                if(this.$parent.item.properties) {
                    return JSON.stringify(JSON.parse(this.$parent.item.properties), null, 2);
                }
                return this.$t('translations.no_properties_specified');
            }
        }
    };
</script>
